/**
 * 鉴权服务 API
 */
import { request } from './request';

// 用户信息接口
export interface UserInfo {
  id: string;
  username: string;
  email: string;
  phone: string;
  realName: string;
  userType: 'INTERNAL' | 'CUSTOMER' | 'ADMIN';
  isActive: boolean;
}

// 登录请求参数
export interface LoginParams {
  identifier: string; // 用户ID、邮箱或手机号
  password: string;
}

// 登录响应数据
export interface LoginResponse {
  user: UserInfo;
  needChangePassword: boolean;
}

// 权限信息
export interface PermissionInfo {
  id: string;
  name: string;
  description: string;
  productId: string;
}

// 权限验证参数
export interface VerifyPermissionParams {
  identifier: string;
  permissionId: string;
  productId: string;
}

// 权限验证响应
export interface VerifyPermissionResponse {
  user: UserInfo;
  hasPermission: boolean;
  permission?: PermissionInfo;
}

/**
 * 用户登录验证
 */
export const authLogin = (params: LoginParams) => {
  return request.post<LoginResponse>('/auth/login', params);
};

/**
 * 通过标识符获取用户信息
 * @param identifier 用户ID、邮箱或手机号
 */
export const authGetUser = (identifier: string) => {
  return request.get<UserInfo>(`/auth/user/${identifier}`);
};

/**
 * 获取用户权限列表
 * @param identifier 用户ID、邮箱或手机号
 */
export const authGetUserPermissions = (identifier: string) => {
  return request.get<{ user: UserInfo; permissions: PermissionInfo[] }>(`/auth/user/${identifier}/permissions`);
};

/**
 * 验证用户权限
 */
export const authVerifyPermission = (params: VerifyPermissionParams) => {
  return request.post<VerifyPermissionResponse>('/auth/verify-permission', params);
};

// 产品管理员校验参数
export interface VerifyAdminParams {
  userId: string;
  productId: string;
}

// 产品管理员校验响应
export interface VerifyAdminResponse {
  user?: UserInfo;
  product?: { id: string; name: string; isActive: boolean };
  isAdmin: boolean;
}

/**
 * 验证用户是否是产品管理员
 */
export const authVerifyAdmin = (params: VerifyAdminParams) => {
  return request.post<VerifyAdminResponse>('/auth/verify-admin', params);
};

/**
 * 修改密码
 */
export const authChangePassword = (params: {
  identifier: string;
  oldPassword: string;
  newPassword: string;
}) => {
  return request.put('/auth/password', params);
};
